import { useSearchParams } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { Download, Copy } from 'lucide-react';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';

export function CrewVisualPage() {
  const { templateId } = useParams();
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code') || 'CREW-CODE';

  const copyCode = () => {
    navigator.clipboard.writeText(code);
    toast.success('Code copié !');
  };

  const downloadHTML = () => {
    const element = document.getElementById('visual-content');
    if (!element) return;
    
    const htmlContent = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: system-ui, -apple-system, sans-serif; }
  </style>
</head>
<body>
${element.outerHTML}
</body>
</html>`;
    
    const blob = new Blob([htmlContent], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `mutagim-crew-${templateId}-${code}.html`;
    a.click();
    URL.revokeObjectURL(url);
    toast.success('Template téléchargé !');
  };

  const renderStoryTemplate = () => (
    <div 
      id="visual-content"
      style={{
        width: '1080px',
        height: '1920px',
        background: 'linear-gradient(180deg, #1A1A1A 0%, #000000 50%, #1A1A1A 100%)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '80px',
        position: 'relative',
      }}
    >
      {/* Logo */}
      <div style={{
        position: 'absolute',
        top: '80px',
        fontSize: '48px',
        fontWeight: '900',
        color: '#C0000C',
        letterSpacing: '-2px',
      }}>
        MUTAGIM
      </div>

      {/* Main Content */}
      <div style={{ textAlign: 'center' }}>
        <div style={{
          fontSize: '64px',
          fontWeight: '900',
          color: 'white',
          marginBottom: '40px',
        }}>
          -10%
        </div>
        <div style={{
          fontSize: '32px',
          color: '#999',
          marginBottom: '60px',
        }}>
          sur ta première commande
        </div>
        <div style={{
          background: '#C0000C',
          padding: '40px 80px',
          borderRadius: '20px',
          marginBottom: '60px',
        }}>
          <div style={{
            fontSize: '56px',
            fontWeight: '900',
            color: 'white',
            letterSpacing: '4px',
          }}>
            {code}
          </div>
        </div>
        <div style={{
          fontSize: '28px',
          color: '#666',
        }}>
          mutagim.shop
        </div>
      </div>

      {/* Swipe indicator */}
      <div style={{
        position: 'absolute',
        bottom: '120px',
        fontSize: '24px',
        color: '#666',
      }}>
        Swipe up pour découvrir
      </div>
    </div>
  );

  const renderSquareTemplate = () => (
    <div 
      id="visual-content"
      style={{
        width: '1080px',
        height: '1080px',
        background: '#000000',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '80px',
        position: 'relative',
      }}
    >
      {/* Border */}
      <div style={{
        position: 'absolute',
        inset: '20px',
        border: '3px solid #C0000C',
        borderRadius: '40px',
      }} />

      {/* Content */}
      <div style={{
        fontSize: '48px',
        fontWeight: '900',
        color: '#C0000C',
        marginBottom: '40px',
        letterSpacing: '-2px',
      }}>
        MUTAGIM
      </div>
      
      <div style={{
        fontSize: '120px',
        fontWeight: '900',
        color: 'white',
        marginBottom: '20px',
      }}>
        -10%
      </div>
      
      <div style={{
        fontSize: '32px',
        color: '#999',
        marginBottom: '60px',
      }}>
        avec mon code
      </div>
      
      <div style={{
        background: 'linear-gradient(135deg, #C0000C 0%, #800008 100%)',
        padding: '30px 60px',
        borderRadius: '16px',
        marginBottom: '40px',
      }}>
        <div style={{
          fontSize: '48px',
          fontWeight: '900',
          color: 'white',
          letterSpacing: '3px',
        }}>
          {code}
        </div>
      </div>
      
      <div style={{
        fontSize: '24px',
        color: '#666',
      }}>
        Streetwear Premium · mutagim.shop
      </div>
    </div>
  );

  const renderProductTemplate = () => (
    <div 
      id="visual-content"
      style={{
        width: '1080px',
        height: '1350px',
        background: 'linear-gradient(180deg, #1A1A1A 0%, #000000 100%)',
        display: 'flex',
        flexDirection: 'column',
        padding: '60px',
        position: 'relative',
      }}
    >
      {/* Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '40px',
      }}>
        <div style={{
          fontSize: '36px',
          fontWeight: '900',
          color: '#C0000C',
        }}>
          MUTAGIM
        </div>
        <div style={{
          background: '#C0000C',
          padding: '12px 24px',
          borderRadius: '8px',
        }}>
          <span style={{ color: 'white', fontWeight: 'bold', fontSize: '24px' }}>-10%</span>
        </div>
      </div>

      {/* Product placeholder */}
      <div style={{
        flex: 1,
        background: '#2A2A2A',
        borderRadius: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '40px',
      }}>
        <div style={{ color: '#666', fontSize: '24px' }}>
          [Glissez votre image produit ici]
        </div>
      </div>

      {/* Code */}
      <div style={{ textAlign: 'center' }}>
        <div style={{ color: '#999', fontSize: '24px', marginBottom: '20px' }}>
          Utilise mon code
        </div>
        <div style={{
          display: 'inline-block',
          background: 'linear-gradient(135deg, #C0000C 0%, #800008 100%)',
          padding: '20px 50px',
          borderRadius: '12px',
        }}>
          <span style={{
            fontSize: '40px',
            fontWeight: '900',
            color: 'white',
            letterSpacing: '3px',
          }}>
            {code}
          </span>
        </div>
      </div>
    </div>
  );

  const templates = {
    story: { render: renderStoryTemplate, name: 'Story Instagram (9:16)' },
    square: { render: renderSquareTemplate, name: 'Post Carré (1:1)' },
    product1: { render: renderProductTemplate, name: 'Produit 1' },
    product2: { render: renderProductTemplate, name: 'Produit 2' },
    product3: { render: renderProductTemplate, name: 'Produit 3' },
  };

  const template = templates[templateId] || templates.story;

  return (
    <div className="min-h-screen bg-zinc-900 py-8 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-2xl font-bold text-white">{template.name}</h1>
            <p className="text-zinc-400">Code promo: <span className="text-[#C0000C] font-bold">{code}</span></p>
          </div>
          <div className="flex gap-3">
            <Button
              onClick={copyCode}
              variant="outline"
              className="border-zinc-700 text-zinc-400 hover:text-white"
            >
              <Copy className="w-4 h-4 mr-2" />
              Copier code
            </Button>
            <Button
              onClick={downloadHTML}
              className="bg-[#C0000C] hover:bg-[#A0000A] text-white"
            >
              <Download className="w-4 h-4 mr-2" />
              Télécharger HTML
            </Button>
          </div>
        </div>

        {/* Instructions */}
        <div className="bg-zinc-800/50 border border-zinc-700 rounded-lg p-4 mb-8">
          <p className="text-zinc-400 text-sm">
            <strong className="text-white">Instructions :</strong> Téléchargez le HTML puis ouvrez-le dans votre navigateur. 
            Faites une capture d'écran ou utilisez un outil de conversion HTML → PNG.
            Vous pouvez aussi personnaliser le HTML avant de le convertir.
          </p>
        </div>

        {/* Preview */}
        <div className="bg-zinc-800/30 border border-zinc-700 rounded-xl p-8 overflow-auto">
          <div className="inline-block" style={{ transform: 'scale(0.4)', transformOrigin: 'top left' }}>
            {template.render()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CrewVisualPage;
